var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showTab === "list",
              expression: "showTab === 'list'"
            }
          ],
          staticClass: "details-view"
        },
        [
          _c(
            "div",
            { staticClass: "search-bar" },
            [
              _c(
                "el-form",
                {
                  staticClass: "search-form",
                  attrs: { inline: true, model: _vm.searchForm }
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("span", { staticClass: "search-label" }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FormName")) + "：")
                      ]),
                      _c("el-input", {
                        staticClass: "search-input",
                        attrs: {
                          placeholder: _vm.$t(
                            "CargoMsg.Cargo_QuickSearchCustomPage"
                          ),
                          clearable: ""
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearch($event)
                          }
                        },
                        model: {
                          value: _vm.searchForm.keyword,
                          callback: function($$v) {
                            _vm.$set(_vm.searchForm, "keyword", $$v)
                          },
                          expression: "searchForm.keyword"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t(
                              "CargoMsg.Cargo_ApplicationScene"
                            ),
                            clearable: ""
                          },
                          model: {
                            value: _vm.searchForm.applicationScene,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "applicationScene", $$v)
                            },
                            expression: "searchForm.applicationScene"
                          }
                        },
                        _vm._l(_vm.applicationSceneOptions, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("CargoMsg.Cargo_BusinessType"),
                            clearable: ""
                          },
                          model: {
                            value: _vm.searchForm.businessType,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "businessType", $$v)
                            },
                            expression: "searchForm.businessType"
                          }
                        },
                        _vm._l(_vm.businessTypeOptions, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("CargoMsg.Cargo_Status"),
                            clearable: ""
                          },
                          model: {
                            value: _vm.searchForm.enabled,
                            callback: function($$v) {
                              _vm.$set(_vm.searchForm, "enabled", $$v)
                            },
                            expression: "searchForm.enabled"
                          }
                        },
                        _vm._l(_vm.enableStatusOptions, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "padding-left": "10px" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSearch }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("CargoMsg.Cargo_Query")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleAdd }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("CargoMsg.Cargo_Add")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleCopy }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("CargoMsg.Cargo_Copy")) + " "
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: { click: _vm.handleDelete }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("CargoMsg.Cargo_Delete")) + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "grid-view" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    key: _vm.gridKey,
                    attrs: {
                      "config-module": "2025062001",
                      "grid-options": _vm.gridOptions,
                      "grid-params": _vm.gridParams,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.tableData
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _c("div", { staticClass: "pagination-wrapper" }, [
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "2025062002",
                    total: _vm.pagination.total,
                    page: _vm.pagination.pageNum,
                    limit: _vm.pagination.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.pagination, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.pagination, "pageSize", $event)
                    },
                    pagination: _vm.handlePagination
                  }
                })
              ],
              1
            )
          ])
        ]
      ),
      _vm.showTab === "detail"
        ? _c("ai-custom-page-detail", {
            ref: "pageDetail",
            attrs: { "form-config": _vm.formConfig, "form-uuid": _vm.formUuid },
            on: { goBack: _vm.handleBack, config: _vm.handleConfig }
          })
        : _vm._e(),
      _c("ai-custom-page-form-config", {
        attrs: {
          visible: _vm.formConfigVisible,
          "form-config": _vm.formConfig,
          "is-create-mode": _vm.isCreateMode
        },
        on: {
          "update:visible": function($event) {
            _vm.formConfigVisible = $event
          },
          confirm: _vm.handleFormConfigConfirm,
          cancel: _vm.handleFormConfigCancel
        }
      }),
      _c(
        "el-dialog",
        {
          staticClass: "preview-dialog-wrapper",
          attrs: {
            visible: _vm.previewDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_Preview"),
            fullscreen: false,
            "show-close": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "custom-class": "preview-dialog",
            modal: true,
            "append-to-body": true,
            "modal-append-to-body": true,
            width: "70%",
            top: "20px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.previewDialog, "visible", $event)
            }
          }
        },
        [
          _vm.previewDialog.visible
            ? _c("ai-custom-page-data-view", {
                attrs: {
                  "page-parts": _vm.previewFormConfig.pageParts,
                  "form-config": _vm.previewFormConfig,
                  "form-data": _vm.safeParseJson(
                    _vm.previewFormConfig.formDataJson,
                    {}
                  ),
                  debug: true,
                  readonly: true
                },
                on: {
                  close: function($event) {
                    _vm.previewDialog.visible = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }